// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { linkListStyles } from "@steiner/Overrides/Widgets/Basic/LinkList";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.linkListWrapper = {
    css: css`
        line-height: 17px;
        &.horizontal {
            ${xScreen("lte", "md")} {
                text-align: center;
            }
        }
    `,
};

linkListStyles.titleWrapper = {
    css: css`
        margin-bottom: 8px;
    `,
};

linkListStyles.linkTitle = {
    color: "common.white",
    typographyProps: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
        `,
    },
};

linkListStyles.title = {
    variant: "h6",
    color: "common.white",
    css: css`
        margin-bottom: 0;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        &.horizontal {
            display: inline-block;
            padding: 0 16px 0 0;
            line-height: 17px;

            & > ${StyledButton}:after {
                content: "";
                border-right: 1px solid ${color("common.ui1")};
                padding-left: 16px;
                height: 13px;
                display: inline-block;
            }

            &:last-child {
                padding: 0;
                & > ${StyledButton}:after {
                    display: none;
                }
            }
        }

        &.vertical {
            & > ${StyledButton} {
                margin-bottom: 10px;
            }
            &:last-child {
                & > ${StyledButton} {
                    margin-bottom: 0;
                }
            }
        }
    `,
};

linkListStyles.link = {
    color: "common.white",
    typographyProps: {
        size: 12,
        css: css`
            line-height: 17px;
        `,
    },
    css: css`
        &.vertical {
            & > ${TypographyStyle} {
                font-weight: normal;
            }
        }
    `,
};
